"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const utils_1 = require("../utils");
const Heading = (props) => {
    let { text } = props;
    const { level, cySelector } = props;
    text = { __html: text };
    const myClassName = (0, utils_1.createCssClassByProps)(props);
    switch (level) {
        case 1:
            return (react_1.default.createElement("h1", { className: myClassName, dangerouslySetInnerHTML: text, "cy-data": cySelector }));
        case 2:
            return (react_1.default.createElement("h2", { className: myClassName, dangerouslySetInnerHTML: text, "cy-data": cySelector }));
        case 3:
            return (react_1.default.createElement("h3", { className: myClassName, dangerouslySetInnerHTML: text, "cy-data": cySelector }));
        case 4:
            return (react_1.default.createElement("h4", { className: myClassName, dangerouslySetInnerHTML: text, "cy-data": cySelector }));
        case 5:
            return (react_1.default.createElement("h5", { className: myClassName, dangerouslySetInnerHTML: text, "cy-data": cySelector }));
        case 6:
            return (react_1.default.createElement("h6", { className: myClassName, dangerouslySetInnerHTML: text, "cy-data": cySelector }));
        default:
            return (react_1.default.createElement("h1", { className: myClassName, dangerouslySetInnerHTML: text, "cy-data": cySelector }));
    }
};
Heading.propTypes = {
    /**
     * {
     *  "info": "Establece el texto que aparecerá dentro del componente",
     *  "kind": "both",
     *  "beautifulName": "Texto"
     * }
     */
    text: prop_types_1.default.string.isRequired,
    /**
     * {
     *  "info": "Define el nivel del encabezado",
     *  "kind": "both",
     *  "beautifulName": "Nivel encabezado"
     * }
     */
    level: prop_types_1.default.number.isRequired,
};
exports.default = Heading;
//# sourceMappingURL=index.js.map